import servicioHttp from './ServicioHttp';
import servicioObjetos from './ServicioAsignacionValoresObjetos';
import { deleteToken, deleteUsuario, setToken, setUsuario } from "./ServicioManejadorToken";

export function autenticar(usuario, contrasena) {
    return new Promise(function (resolve, reject) {
        deleteToken();
        deleteUsuario();
        servicioHttp.consumirPostHttp('/autenticar?usuario='+usuario+'&contrasena='+encodeURIComponent(contrasena)).then((response) => {
            let tokenAutorizacion = response.headers.authorization;
            let usuarioSistema = response.headers.user;
            setToken(tokenAutorizacion);
            setUsuario(usuarioSistema);
            resolve("autenticado");
        }).catch((error) => {            
            if (!servicioObjetos.esObjetoVacio(error.response)) {
                if (error.response.status === 401) {
                    if (!servicioObjetos.esObjetoVacio(error.response.data)) {
                        reject(error.response.data.mensaje);
                    }
                } else {
                    reject("Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde");
                }
            }else{
                reject("Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde");
            }
        });
    });
}